jQuery(document).ready(function ($) {
    // $('.slick-carousel').slick();

    // override multiselect
    if (document.querySelector("#wpbdp-field-12")) {
        var e = document.getElementById("wpbdp-field-12");
        e.removeAttribute('multiple');
    }

    // add aria-label for accessibility
    if (document.querySelector("div.wpbdp-show-on-mobile select")) {
        var e = document.querySelector("div.wpbdp-show-on-mobile select");
        e.setAttribute('aria-label', 'Sort By - options');
    }

    // menu behavior update

    jQuery(function ($) {
        $('.navbar .dropdown').hover(function () {
            $(this).find('.dropdown-menu').first().stop(true, true).delay(250).slideDown();

        }, function () {
            $(this).find('.dropdown-menu').first().stop(true, true).delay(100).slideUp();

        });

        $('.navbar .dropdown > a').click(function () {
            location.href = this.href;
        });

    });

});
